import React from "react";
import { Link } from "react-router-dom";

function MenuItem({ image, name, description, link }) {
  return (
    <Link to={link} className="menuItem">
      <div style={{ backgroundImage: `url(${image})` }}> </div>
      <h1> {name} </h1>
      <p className="menuItemDescription"> {description} </p>
    </Link>
  );
}

export default MenuItem;
